import { MagicOneTimeCodeRegex } from "../../components/inputs/input-regex-constants";

/**
 * check if input ott length is valid
 * @param value to check for length
 * @param ottRegex Regex pattern of ott
 * @returns true if input is valid length numbers
 */
export function isValidLengthOtt(value: string, ottRegex: string): boolean {
  return !!value.match(ottRegex);
}

/**
 * Validates if the input is all digits
 * @param value - OTC entered
 * @param bypassClientProofValidationWithZero - flag to bypass validation with
 * @param ottRegex Regex pattern of ott
 * @returns true if input contains all digits; false otherwise.
 */
export function isValidOtt(
  value: string,
  bypassClientProofValidationWithZero: boolean,
  ottRegex: string,
): boolean {
  if (bypassClientProofValidationWithZero && value && value.match(MagicOneTimeCodeRegex)) {
    return true;
  }

  return isValidLengthOtt(value, ottRegex);
}
